import { useMemo } from 'react'
import { useQuery } from './useQuery'
import { createQueryCodec } from './AppUrlQueryCodec'
import { UseQueryState } from '../types'
import { MappingSchema } from '../../serialization/types'

export const useQueryState: UseQueryState = <T>(
    fields: MappingSchema,
    prefix?: string,
    defaults?: Partial<T>
) => {
    const [
        q,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
        _,
        merge
    ] = useQuery()

    const codec = useMemo(() => createQueryCodec<T>(fields, prefix), [])

    return [
        // TODO improve
        { ...defaults, ...codec.decode(q) },
        (t: T) => {
            merge(codec.encode(t))
        }
    ]
}
